import styled from "styled-components";

export const TopMenuContainer = styled.div`
  && {
    background-color: #ffffff;
    position: sticky;
    top: 50px;
    z-index: 999;
  }
`;
